import { render, staticRenderFns } from "./FuxaArtwork.vue?vue&type=template&id=1156100e&scoped=true"
import script from "./FuxaArtwork.vue?vue&type=script&lang=js"
export * from "./FuxaArtwork.vue?vue&type=script&lang=js"
import style0 from "./FuxaArtwork.vue?vue&type=style&index=0&id=1156100e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156100e",
  null
  
)

export default component.exports